import { resolveMediaUrl } from '../api/client';

/**
 * AB#636 (mobile parity for #614 v2 / #623): resolve a site-asset reference
 * from site settings (favicon_url today; og_image would qualify too) into a URL
 * that actually loads — from the admin, from the desktop shell's
 * tauri://localhost origin, and from React Native (which has NO origin at all
 * to resolve a root-relative path against). Three shapes exist in the wild:
 *  - absolute http(s)://...        -> as-is
 *  - /media/... (admin upload)     -> API origin via resolveMediaUrl (AB#432)
 *  - theme-relative ("favicon.svg") or any other root-relative path
 *                                  -> joined to the PUBLISHED site's own root
 *                                     (settings.url); SSG copies theme statics
 *                                     there, e.g. wordpuppi.com/favicon.svg.
 * Returns null when no loadable URL can be produced (empty value, or a
 * site-relative asset with no site url) — callers must render a placeholder or
 * nothing, never a broken image.
 *
 * ponytail: wpp-admin still carries its own copy at src/lib/siteAssets.ts;
 * collapsing it to `export { resolveSiteAssetUrl } from '@wordpuppi/shared'` is
 * a one-line follow-up, deferred here only because wpp-admin was locked by a
 * concurrent editor.
 */
export function resolveSiteAssetUrl(
  value: string | null | undefined,
  siteUrl: string | null | undefined,
): string | null {
  if (!value) return null;
  if (/^https?:\/\//i.test(value)) return value;
  if (value.startsWith('/media/')) return resolveMediaUrl(value);
  if (!siteUrl) return null;
  return `${siteUrl.replace(/\/$/, '')}/${value.replace(/^\//, '')}`;
}
